import React from 'react';
import GameTable from './gameTable';

import img1 from './img/connect6.jpg';//TODO: find better method to import src
import img2 from './img/bloody99.png';
import img3 from './img/sophia.png';
import img4 from './img/collect-stars.png';
//import GameData from './gamedata.json';

//tip: cannot render two elements by render at the same container
//TODO: move to json file(need json-loader) https://stackoverflow.com/questions/38129727/import-a-json-file-in-a-react-component
const gameData = [
    {
        img: img1, name: "connect 6", link: "http://sixchess.qwerty777.me/",
        description: "Method: simple heuristic"
    },
    {
        img: img2, name: "bloody 99", link: "http://bloody99.qwerty777.me/",
        description: "Method: Alpha-Beta Search based on card value, heuristic, monte-carlo search<br />" +
            "Bloody99 is an addition poker game modified from 99, which is well- known in Taiwan.<br />" +
            "Also including GUI using PyGame."
    },
    {
        img: img3, name: "sophia", link: "http://sophia.qwerty777.me/",
        description: "An English-learning interactive fiction game"
    },
    {
        img: img4, name: "collect stars", link: "http://collectstars.qwerty777.me/",
        description: "An English-learning spelling game"
    }
]

//cannot return two tags simultaneously, use empty tag
function App() {
    return (
        <>
            <h2>Games</h2>
            <div id="gameTable"><GameTable data={gameData} /></div>
        </>
    );
}

//export default is used to export a single class, function or primitive from a script file.
export default App;
